import api from "./Api";

export const subscribeToBlog = (email) =>
  api.post("Service/subscribe", null, {
    params: { email },
  });
